module.exports = __webpack_public_path__ + "img/section_kanban.fc16b667.png";